import React, { Component } from "react";
import "./AddSubscription.css";
import ContextConstructor from "../../components/Context/Context";
import SeriesSelection from "./SeriesSelection";
import AmountForm from "./AmountForm";
import TermsStep from "./TermsStep";
import ConfirmationStep from "./ConfirmationStep";
import ResultStep from "./ResultStep";
import sendLogError from "../../sendLogError";

import loadingImg from "../../images/loading.svg";

const minimoPorPeriodicidade = {
    Mensal: 10,
    Trimestral: 25,
    Semestral: 50,
    Anual: 100,
    Única: 0,
};

const CONSTANTS = {
    TOAST_DURATION: 4000,
    MIN_AMOUNT_PRAZO_MUTUALISTA: 150,
    MIN_AMOUNT_PRAZO_EXPRESS: 250,
    MIN_AMOUNT: 100,
    MAX_AMOUNT: 500000,
    CORRECT_DEADLINE: "7385",
};

const API = {
    GET_PAGE: "/Savings/GetSavingPage",
    POPULATE: "/Savings/PopulateSavings",
    CREATE: "/Savings/CreateSavings",
    GET_SERIES: "/Savings/GetSeries",
};

const productIdToSlug = (productId) => {
    if (!productId) return "poupanca-complementar";
    const id = String(productId || "").trim();
    if (id.startsWith("7385")) return "poupanca-capital-certo";
    if (id.startsWith("7375")) return "poupanca-reforma";
    if (id.startsWith("7365")) return "poupanca-complementar";
    if (id.startsWith("7335")) return "plano-de-longevidade";
    return "poupanca-complementar";
};

const parseUmbracoContent = (content) => {
    if (!content) return {};

    const props = content.properties || {};

    return {
        id: content.id,
        contentType: content.contentType,
        texto: props.MGAM_texto || props.texto || "",
        titulo: props.MGAM_titulo || props.titulo || "",
        properties: props
    };
};

class AddSubscription extends Component {
    constructor(props) {
        super(props);
        this.state = {
            currentStep: 0,
            seriesList: [],
            selectedSerie: null,

            montante: "",
            periodicidade: "Livre",
            metodoPagamento: "Multibanco",
            montanteProgramado: "",

            erroMontante: true,
            erroMontanteProgramado: false,
            mensagemErro: "",
            subscricaoFeita: false,
            erroSubscricao: false,
            subscricaoLoading: false,
            manualMode: false,
            manualBannerMsg: "",
            manualFields: {
                associateReference: "",
                associateEmail: "",
            },
            reapply: false,
            isPrazoCerto: false,
            savingsInfo: null,
            pageTitle: "",
            pageTexts: [],
            pageTerms: [],
            pageDocuments: [],
            pageMinAmount: null,
            pageMaxAmount: null,

            pageTextoMontante: "",
            pageTextoTipoSubscricao: "",
            pageTextoBeneficiario: "",
            pageTextoProjecaoValores: "",
            pageTextoReaplicar: "",
            pageTooltip: [],

            acceptedTerms: {},
            acceptedDocs: {},
            canContinueTerms: false,

            loadingCms: false,
        };
    }

    async componentDidMount() {
        const isPrazoCerto =
            (this.props.modalidade.productID || "").toLowerCase() === CONSTANTS.CORRECT_DEADLINE;
        this.setState({ isPrazoCerto });

        await this.fetchSubscriptionPage();

        if (isPrazoCerto) {
            await this.fetchSeries();
        } else {
            this.setState({ currentStep: 1 }, () => this.populateSavings());
        }
    }

    handleToggleReapply = () => {
        this.setState(prev => ({ reapply: !prev.reapply }), () => {

        });
    };

    isTxnInactiveError = (textOrObj) => {
        try {
            const toStringSafe = (v) => (v == null ? "" : String(v));

            let candidate = "";
            if (typeof textOrObj === "string") {
                candidate = textOrObj;
            } else if (textOrObj && typeof textOrObj === "object") {
                candidate =
                    toStringSafe(textOrObj.details?.message) ||
                    toStringSafe(textOrObj.message) ||
                    toStringSafe(textOrObj.errorMessage) ||
                    toStringSafe(textOrObj.Message) ||
                    JSON.stringify(textOrObj);
            } else {
                candidate = toStringSafe(textOrObj);
            }

            const normalize = (s) =>
                s
                    .replace(/\\u00([0-9a-fA-F]{2})/g, (_, hex) =>
                        String.fromCharCode(parseInt(hex, 16))
                    )
                    .normalize("NFD")
                    .replace(/[\u0300-\u036f]/g, "")
                    .replace(/[\u2010-\u2015]/g, "-")
                    .replace(/\s+/g, " ")
                    .toUpperCase()
                    .trim();

            const norm = normalize(candidate);

            const hit = /(^|\D)10\s*-\s*A\s*TRANSACAO\s+ESTA\s+INATIVA(\b|$)/.test(norm);
            return hit || (norm.includes(" 10 ") && norm.includes("INATIV") && norm.includes("TRANSACAO"));
        } catch {
            return false;
        }
    };

    showErrorToast = (mensagem) => {
        const toast = document.createElement("div");
        toast.className = "toast-error";
        toast.innerText = mensagem || "Ocorreu um erro. Tente novamente.";

        document.body.appendChild(toast);
        setTimeout(() => {
            toast.remove();
        }, CONSTANTS.TOAST_DURATION);
    };

    fetchSubscriptionPage = async () => {
        try {
            const idToken = this.context?.idToken;

            if (!idToken) {
                this.showErrorToast("Sessão inválida. Tente novamente.");
                setTimeout(() => this.props.onClose?.(), CONSTANTS.TOAST_DURATION);
                return;
            }

            this.setState({ loadingCms: true });

            const productId = this.props?.modalidade?.productID || "";
            const slug = productIdToSlug(productId);

            const res = await fetch(
                `${API.GET_PAGE}?slug=${encodeURIComponent(slug)}`,
                {
                    headers: {
                        Authorization: `Bearer ${idToken}`,
                    },
                }
            );

            if (!res.ok) {
                throw new Error(`Erro HTTP: ${res.status}`);
            }

            const json = await res.json();

            if (!json) {
                throw new Error("Resposta CMS vazia");
            }

            const pageTitle = json?.title || this.props.productName || "";

            const pageTexts = Array.isArray(json?.textos)
                ? json.textos.filter(Boolean)
                : [];

            const pageTerms = Array.isArray(json?.termosECondicoes)
                ? json.termosECondicoes
                    .map((t) => ({
                        id: t.id || t.Id,
                        texto: t.texto || t.Texto,
                    }))
                    .filter((x) => x?.texto)
                : [];

            const pageDocuments = Array.isArray(json?.documentos)
                ? json.documentos.map((d) => ({
                    id: d.id || d.Id,
                    nome: d.nome || d.Nome || d.name || d.Name,
                    url: d.url || d.Url,
                    extension: d.extension || d.Extension,
                    bytes: d.bytes ?? d.Bytes,
                }))
                : [];

            const pageTextoMontante = json?.textoMontante || "";
            const pageTextoTipoSubscricao = json?.textoTipoSubscricao || "";
            const pageTextoBeneficiario = json?.textoBeneficiario || "";
            const pageTextoProjecaoValores = json?.textoProjecaoValores || "";
            const pageTextoReaplicar = json?.textoReaplicar || "";
            const pageMinAmount = json?.limiteMinimo;
            const pageMaxAmount = json?.limiteMaximo;

            // TOOLTIP
            const allProps = json?.allProperties || {};
            const tooltipRaw = allProps.MGAM_tooltip || allProps.mGAM_tooltip;

            let pageTooltip = [];

            if (tooltipRaw) {
                try {
                    const tooltipObj =
                        typeof tooltipRaw === "string"
                            ? JSON.parse(tooltipRaw)
                            : tooltipRaw;

                    const active = tooltipObj?.items?.find(
                        (item) =>
                            item?.content?.properties?.ativoinativo === "Ativo"
                    );

                    pageTooltip =
                        active?.content?.properties?.tooltip?.items?.flatMap(
                            (item) => {
                                const elementos =
                                    item?.content?.properties
                                        ?.MGAM_elementosPagina?.items || [];

                                return elementos.map((elem) =>
                                    parseUmbracoContent(elem.content)
                                );
                            }
                        ) ?? [];
                } catch (e) {
                    console.warn("Tooltip parse failed", e);
                    pageTooltip = [];
                }
            }

            this.setState({
                loadingCms: false,
                pageTitle,
                pageTexts,
                pageTerms,
                pageDocuments,
                pageMinAmount,
                pageMaxAmount,
                pageTextoMontante,
                pageTextoTipoSubscricao,
                pageTextoBeneficiario,
                pageTextoProjecaoValores,
                pageTextoReaplicar,
                pageTooltip,
            });

        } catch (error) {
            console.error("Error fetching subscription page:", error);

            this.setState({ loadingCms: false });

            sendLogError(error.message, "fetchSubscriptionPage");
        }
    };

    fetchSeries = async () => {
        try {
            const { idToken } = this.context;

            if (!idToken) {
                this.handleSeriesError("Sessão inválida. Tente novamente.");
                return;
            }

            const response = await fetch(API.GET_SERIES, {
                headers: {
                    Authorization: `Bearer ${idToken}`,
                },
            });

            if (!response.ok) {
                throw new Error(`Erro HTTP: ${response.status}`);
            }

            const result = await response.json();

            this.setState({
                seriesList: Array.isArray(result) ? result : []
            });

        } catch (error) {
            console.error("Error fetching series:", error);

            sendLogError(error.message, "fetchSeries");

            this.handleSeriesError("Erro ao carregar séries. Tente novamente.");
        }
    };

    handleSeriesError(message) {
        this.showErrorToast(message);
        setTimeout(() => this.props.onClose?.(), CONSTANTS.TOAST_DURATION);
    }

    handleSerieChange = (serie, index) => {
        this.setState(prev => {

            const minFromSerie = Number(
                serie?.limiteMinimo ?? serie?.minimumLimit ?? 0
            );
            const maxFromSerie = Number(
                serie?.limiteMaximo ?? serie?.maximumLimit ?? 0
            );


            const baseDocs = prev.pageDocuments || [];

            const serieAttachmentsRaw =
                serie?.documentosAnexos ||
                serie?.documentsAttachments ||
                [];

            const serieAttachments = serieAttachmentsRaw.map(d => ({
                id: d.id || d.Id,
                nome: d.nome || d.name,
                url: d.url,
                extension: d.extension,
                bytes: d.bytes,
            }));


            const mergedDocs = [...baseDocs];
            const seen = new Set(
                baseDocs.map(d => `${d.id || ""}|${d.url || ""}`)
            );

            for (const d of serieAttachments) {
                const key = `${d.id || ""}|${d.url || ""}`;
                if (!seen.has(key)) {
                    mergedDocs.push(d);
                    seen.add(key);
                }
            }


            let mergedTooltip = prev.pageTooltip || [];

            const serieTooltipRaw =
                serie?.tooltipJson ||
                serie?.tooltip ||
                null;

            if (serieTooltipRaw) {
                try {
                    const tooltipObj =
                        typeof serieTooltipRaw === "string"
                            ? JSON.parse(serieTooltipRaw)
                            : serieTooltipRaw;

                    const active =
                        tooltipObj?.items?.find(
                            item =>
                                item?.content?.properties?.ativoinativo === "Ativo"
                        ) || null;

                    const serieTooltip =
                        active?.content?.properties?.tooltip?.items?.flatMap(
                            (item) => {
                                const elementos =
                                    item?.content?.properties
                                        ?.MGAM_elementosPagina?.items || [];

                                return elementos.map(elem =>
                                    parseUmbracoContent(elem.content)
                                );
                            }
                        ) || [];

                    if (serieTooltip.length) {
                        mergedTooltip = [...mergedTooltip, ...serieTooltip];
                    }
                } catch {

                }
            }

            return {
                selectedSerie: serie,
                selectedIndex: index,


                pageMinAmount:
                    prev.isPrazoCerto && minFromSerie > 0
                        ? minFromSerie
                        : prev.pageMinAmount,
                pageMaxAmount:
                    prev.isPrazoCerto && maxFromSerie > 0
                        ? maxFromSerie
                        : prev.pageMaxAmount,


                pageDocuments: mergedDocs,
                pageTooltip: mergedTooltip,
            };
        });
    };


    handleAdvanceFromSeries = async () => {
        const { selectedSerie } = this.state;
        if (!selectedSerie) return;

        await new Promise((resolve) => {
            this.setState({ currentStep: 1 }, resolve);
        });

        await this.populateSavings();
    };

    async populateSavings() {
        try {
            const { modalidade, onClose } = this.props;
            const user = this.context?.selectedUser;
            const { idToken } = this.context;
            const { selectedSerie } = this.state;

            if (!user?.associateID || !idToken) {
                this.handleSavingsError("Informações do utilizador incompletas.", onClose);
                return;
            }

            const productID = modalidade?.productID || "";

            const payload = {
                associateReference: user.associateID,
                productNumber: selectedSerie?.productNumber || productID.slice(0, 2),
                byproductNumber: selectedSerie?.subProductNumber || productID.slice(2),
                currency: "EUR",
                seriesNumber: selectedSerie?.serieNumber
            };

            const response = await fetch(API.POPULATE, {
                method: "POST",
                headers: {
                    Authorization: `Bearer ${idToken}`,
                    "Content-Type": "application/json"
                },
                body: JSON.stringify(payload)
            });

            if (!response.ok) {
                let errorMessage = "Falha ao registar a resposta dos termos.";
                throw new Error(errorMessage);
            }

            const raw = await response.text();
            let data = null;

            if (raw?.trim()) {
                try {
                    data = JSON.parse(raw);
                } catch {
                    data = null;
                }
            }

            const inactive =
                this.isTxnInactiveError(raw) ||
                this.isTxnInactiveError(data) ||
                data?.isTransactionInactive === true;

            if (inactive) {
                const minimalPopulate = {
                    ...(typeof data === "object" ? data : {}),
                    associateReference: user.associateID,
                    productNumber: payload.productNumber,
                    byproductNumber: payload.byproductNumber,
                    currency: "EUR"
                };

                this.setState({
                    savingsInfo: minimalPopulate,
                    manualMode: true,
                    manualBannerMsg:
                        "As transações estão temporariamente inativas. Para continuar, preencha manualmente os dados em falta.",
                    currentStep: 1
                });
                return;
            }

            if (!response.ok || !data || typeof data !== "object") {
                throw new Error(`Erro HTTP ou dados inválidos (${response.status})`);
            }

            if (data.success === false) {
                const mensagem =
                    data?.details?.message ||
                    data?.errorMessage ||
                    "Erro ao preparar dados de poupança.";

                this.handleSavingsError(mensagem, onClose);
                return;
            }

            this.setState({
                savingsInfo: data,
                manualMode: false,
                manualBannerMsg: ""
            });

        } catch (err) {
            console.error("Error in populateSavings:", err);

            sendLogError(err.message, "populateSavings");

            this.handleSavingsError(
                "Erro ao carregar dados da poupança. Tente novamente.",
                this.props?.onClose
            );
        }
    }

    handleSavingsError(message, onClose) {
        this.showErrorToast(message);
        setTimeout(() => onClose?.(), CONSTANTS.TOAST_DURATION);
    }

    getEffectiveLimits = () => {
        const {
            isPrazoCerto,
            selectedSerie,
            pageMinAmount,
            pageMaxAmount,
        } = this.state;

        let minAmount = null;
        let maxAmount = null;

        if (isPrazoCerto && selectedSerie) {
            const serieMin = Number(
                selectedSerie.limiteMinimo ?? selectedSerie.minimumLimit ?? 0
            );
            const serieMax = Number(
                selectedSerie.limiteMaximo ?? selectedSerie.maximumLimit ?? 0
            );

            if (!Number.isNaN(serieMin) && serieMin > 0) {
                minAmount = serieMin;
            }
            if (!Number.isNaN(serieMax) && serieMax > 0) {
                maxAmount = serieMax;
            }
        }

        if ((minAmount == null || minAmount <= 0) && pageMinAmount != null) {
            const pageMin = Number(pageMinAmount);
            if (!Number.isNaN(pageMin) && pageMin > 0) {
                minAmount = pageMin;
            }
        }

        if ((maxAmount == null || maxAmount <= 0) && pageMaxAmount != null) {
            const pageMax = Number(pageMaxAmount);
            if (!Number.isNaN(pageMax) && pageMax > 0) {
                maxAmount = pageMax;
            }
        }

        if (minAmount == null || minAmount <= 0) {
            if (isPrazoCerto) {
                const serieTitulo = (selectedSerie?.nome || "").toLowerCase();
                if (serieTitulo.includes("poupança mutualista prazo 5.1")) {
                    minAmount = CONSTANTS.MIN_AMOUNT_PRAZO_MUTUALISTA;
                } else if (serieTitulo.includes("poupança expresso net")) {
                    minAmount = CONSTANTS.MIN_AMOUNT_PRAZO_EXPRESS;
                } else {
                    minAmount = CONSTANTS.MIN_AMOUNT;
                }
            } else {
                minAmount = CONSTANTS.MIN_AMOUNT;
            }
        }

        if (maxAmount == null || maxAmount <= 0) {
            maxAmount = CONSTANTS.MAX_AMOUNT;
        }

        return { minAmount, maxAmount };
    };

    handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        const newValue = type === "checkbox" ? checked : value;

        let periodicidade = name === "periodicidade" ? value : this.state.periodicidade;
        const montante = name === "montante" ? value : this.state.montante;
        let montanteProgramado =
            name === "montanteProgramado" ? value : this.state.montanteProgramado;

        if (name === "periodicidade") {
            montanteProgramado = "";
        }

        if (name === "montanteProgramado") {
            const parsed = parseFloat(value || 0);
            if (parsed <= 0) {
                periodicidade = "Livre";
            } else if (this.state.periodicidade === "Livre") {
                periodicidade = "Mensal";
            }
            montanteProgramado = value;
        }

        if (name === "montante") {
            const parsedMontante = parseFloat(value || 0);
            if (!Number.isNaN(parsedMontante) && parsedMontante < 100) {
                periodicidade = "Livre";
                montanteProgramado = "";
            }
        }

        const { minAmount, maxAmount } = this.getEffectiveLimits();

        const parsedMontante = parseFloat(montante);
        const parsedProgramado = parseFloat(montanteProgramado);
        const minimoPermitido = minimoPorPeriodicidade[periodicidade] || 0;

        const erroMontante =
            Number.isNaN(parsedMontante) ||
            parsedMontante < minAmount ||
            parsedMontante > maxAmount;

        const erroMontanteProgramado =
            periodicidade !== "Única" &&
            periodicidade !== "Livre" &&
            (Number.isNaN(parsedProgramado) || parsedProgramado < minimoPermitido);

        this.setState({
            [name]: newValue,
            periodicidade,
            montanteProgramado,
            erroMontante,
            erroMontanteProgramado,
        });
    };



    getEffectiveMinMax = () => {
        const {
            isPrazoCerto,
            selectedSerie,
            pageMinAmount,
            pageMaxAmount,
        } = this.state;

        let min = null;
        let max = null;

        if (isPrazoCerto && selectedSerie) {
            const rawMin =
                selectedSerie.minimumLimit ??
                selectedSerie.minAmount ??
                selectedSerie.limiteMinimo ??
                selectedSerie.LimiteMinimo;

            const rawMax =
                selectedSerie.maximumLimit ??
                selectedSerie.maxAmount ??
                selectedSerie.limiteMaximo ??
                selectedSerie.LimiteMaximo;
            console.log(rawMin, rawMax)
            const parsedMin = rawMin != null ? parseFloat(rawMin) : NaN;
            const parsedMax = rawMax != null ? parseFloat(rawMax) : NaN;
            console.log(parsedMax, parsedMin)
            if (!Number.isNaN(parsedMin)) min = parsedMin;
            if (!Number.isNaN(parsedMax)) max = parsedMax;
        }

        if (!isPrazoCerto) {
            const parsedPageMin =
                pageMinAmount != null ? parseFloat(pageMinAmount) : NaN;
            const parsedPageMax =
                pageMaxAmount != null ? parseFloat(pageMaxAmount) : NaN;

            if (!Number.isNaN(parsedPageMin)) min = parsedPageMin;
            if (!Number.isNaN(parsedPageMax)) max = parsedPageMax;
        }

        if (min == null) {
            if (isPrazoCerto) {
                const serieTitulo = (
                    selectedSerie?.nome ||
                    selectedSerie?.name ||
                    ""
                ).toLowerCase();

                if (serieTitulo.includes("poupança mutualista prazo 5.1")) {
                    min = CONSTANTS.MIN_AMOUNT_PRAZO_MUTUALISTA;
                } else if (serieTitulo.includes("poupança expresso net")) {
                    min = CONSTANTS.MIN_AMOUNT_PRAZO_EXPRESS;
                } else {
                    min = CONSTANTS.MIN_AMOUNT;
                }
            } else {
                min = CONSTANTS.MIN_AMOUNT;
            }
        }

        if (max == null) {
            max = CONSTANTS.MAX_AMOUNT;
        }

        return { minAmount: min, maxAmount: max };
    };
    handleNext = () => {
        this.setState(prev => ({ currentStep: Math.min(prev.currentStep + 1, 4) }));
    };

    handleBack = () => {
        this.setState(prev => ({ currentStep: Math.max(prev.currentStep - 1, 1) }));
    };

    shouldShowBackButton = () => {
        const { currentStep, subscricaoFeita, erroSubscricao } = this.state;
        return currentStep === 1 || (currentStep > 1 && currentStep < 4 && !subscricaoFeita && !erroSubscricao);
    };

    shouldShowNextButton = () => {
        const {
            currentStep,
            erroMontante,
            erroMontanteProgramado,
            isPrazoCerto,
            periodicidade,
            canContinueTerms,
        } = this.state;

        if (currentStep === 1) {
            const parsedMontante = parseFloat(this.state.montante || 0);
            const parsedProgramado = parseFloat(this.state.montanteProgramado || 0);


            if (parsedMontante < 100) {
                if (parsedProgramado <= 0 || this.state.erroMontanteProgramado) {
                    return false;
                }
            }

            const semErroProgramado =
                periodicidade === "Livre" ? true : !erroMontanteProgramado;

            return (!erroMontante && semErroProgramado);
        }

        if (currentStep >= 3) return false;

        if (currentStep === 2) {
            return !!canContinueTerms;
        }

        return true;
    };

    shouldShowConfirmButton = () => {
        const { currentStep, subscricaoFeita, erroSubscricao } = this.state;
        return currentStep === 3 && !subscricaoFeita && !erroSubscricao;
    };

    shouldShowCloseButton = () => {
        const { currentStep, subscricaoFeita, erroSubscricao } = this.state;
        return currentStep === 4 && (subscricaoFeita || erroSubscricao);
    };

    handleSubmit = async () => {
        try {
            const {
                montante,
                montanteProgramado,
                periodicidade,
                savingsInfo,
                isPrazoCerto,
                manualMode,
                manualFields = {},
                selectedSerie,
                reapply,
            } = this.state;

            const { idToken, selectedUser } = this.context;

            if (!idToken || (!manualMode && !savingsInfo)) {
                this.handleSubmitError("Sessão inválida ou dados em falta.");
                return;
            }

            this.setState({ subscricaoLoading: true });

            const initial = parseFloat(montante || 0);
            const frequent =
                periodicidade === "Única" ? 0 : parseFloat(montanteProgramado || 0);

            const productID = this.props?.modalidade?.productID || "";

            const derivedProductNumber =
                selectedSerie?.productNumber || productID.slice(0, 2);

            const derivedByproductNumber =
                selectedSerie?.subProductNumber || productID.slice(2);

            const nowIso = new Date().toISOString();

            const opCodeMap = {
                Mensal: "M01",
                Trimestral: "M03",
                Semestral: "M06",
                Anual: "A01",
                Única: "U00",
                Livre: "L00",
            };

            const derived = {
                startDate: nowIso,
                ValueDate: nowIso,
                OperationDate: nowIso,
                BirthDate: null,
                operationCode: isPrazoCerto
                    ? "U00"
                    : opCodeMap[periodicidade] || "L00",
                initialDelivery: initial,
                deliveryPlan:
                    isPrazoCerto || periodicidade === "Única" || periodicidade === "Livre"
                        ? "B"
                        : "A",
                IndexingPlanCode: "C",
                paymentType: "DEBITO_DIRETO",
                operationAmount: initial + (isPrazoCerto ? 0 : frequent),
                productNumber: derivedProductNumber,
                byproductNumber: derivedByproductNumber,
                currency: "EUR",
            };

            const offlineMinimal = {
                associateReference:
                    manualFields.associateReference ||
                    savingsInfo?.associateReference ||
                    selectedUser?.associateID ||
                    "",
                associateEmail:
                    manualFields.associateEmail ||
                    selectedUser?.mymEmail ||
                    selectedUser?.email ||
                    savingsInfo?.associateEmail ||
                    "",
                ...derived,
                ...(isPrazoCerto ? {} : { frequentDeliveries: frequent }),
            };

            const payload = manualMode
                ? offlineMinimal
                : {
                    ...savingsInfo,
                    operationCode: derived.operationCode,
                    initialDelivery: initial,
                    ...(isPrazoCerto
                        ? {}
                        : {
                            frequentDeliveries: frequent,
                            deliveryPlan: derived.deliveryPlan,
                            IndexingPlanCode: derived.IndexingPlanCode,
                        }),
                    paymentType: derived.paymentType,
                    operationAmount: derived.operationAmount,
                    reapply: reapply ? "S" : "N",
                    AssociatePhoneNumber: selectedUser?.mymTelephone,
                    associateEmail:
                        selectedUser?.mymEmail ||
                        selectedUser?.email ||
                        savingsInfo?.associateEmail,
                };

            const response = await fetch(API.CREATE, {
                method: "POST",
                headers: {
                    Authorization: `Bearer ${idToken}`,
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(payload),
            });

            if (!response.ok) {
                throw new Error(`Erro HTTP: ${response.status}`);
            }

            const result = await response.json();

            if (!result || result.success === false) {
                const mensagem =
                    result?.details?.message ||
                    result?.errorMessage ||
                    "Erro ao processar subscrição.";

                this.setSubmissionError(mensagem);
                return;
            }

            this.setState({
                subscricaoFeita: true,
                currentStep: 4,
            });

        } catch (error) {
            console.error("Error in handleSubmit:", error);

            sendLogError(error.message, "handleSubmit");

            const fallbackMessage =
                error?.message || "Erro inesperado ao tentar subscrever.";

            this.setSubmissionError(fallbackMessage);

        } finally {
            this.setState({ subscricaoLoading: false });
        }
    };

    handleSubmitError(message) {
        this.showErrorToast(message);
        setTimeout(() => this.props.onClose?.(), CONSTANTS.TOAST_DURATION);
    }

    setSubmissionError(message) {
        this.setState({
            erroSubscricao: true,
            mensagemErro: message,
            currentStep: 4,
        });
    }

    renderPasso = () => {
        const {
            currentStep,
            pageTerms,
            pageDocuments,
            acceptedTerms,
            acceptedDocs,
            manualMode,
            manualFields,
            reapply,
        } = this.state;

        const commonProps = {
            ...this.state,
            constants: CONSTANTS,
            onChange: this.handleChange,
            onSubmit: this.handleSubmit,
            selectedSerieName: this.state.selectedSerie?.nome || null,
            productName: this.props.productName,
            productId: this.props.modalidade.productID,
        };

        switch (currentStep) {
            case 1:
                return (
                    <AmountForm
                        {...commonProps}
                        manualMode={manualMode}
                        manualFields={manualFields}
                        onManualChange={(fields) =>
                            this.setState({
                                manualFields: { ...(manualFields || {}), ...fields },
                            })
                        }
                    />
                );

            case 2:
                return (
                    <TermsStep
                        {...commonProps}
                        terms={pageTerms}
                        documents={pageDocuments}
                        acceptedTerms={acceptedTerms}
                        acceptedDocs={acceptedDocs}
                        onChange={({ target: { name, value } }) =>
                            this.setState({ [name]: value })
                        }
                        onAllAcceptedChange={(ok) =>
                            this.setState({ canContinueTerms: ok })
                        }
                    />
                );

            case 3:
                return (
                    <ConfirmationStep
                        {...commonProps}
                        reapply={reapply}
                        onToggleReapply={this.handleToggleReapply}
                    />
                );

            case 4:
                return <ResultStep {...commonProps} onClose={this.props.onClose} />;

            default:
                return null;
        }
    };

    renderSeriesStep() {
        const props = {
            ...this.state,
            onChange: this.handleChange,
            onSubmit: this.handleSubmit,
            productName: this.props.productName,
            onClose: this.props.onClose
        };

        return (
            <SeriesSelection
                {...props}
                onSelect={this.handleSerieChange}
                onAdvance={this.handleAdvanceFromSeries}
            />
        );
    };

    renderFormulario() {
        const { selectedSerie, currentStep, pageTooltip } = this.state;

        const titulo =
            this.state.pageTitle ||
            (selectedSerie == null ? this.props.productName : selectedSerie.nome);

        const hasTooltip = Array.isArray(pageTooltip) && pageTooltip.length > 0;

        return (
            <div className="form-wrapper">
                <div className="titulo-linha">
                    <h1 className="titulo">{titulo}</h1>

                    {hasTooltip && (
                        <div className="subscription-tooltip">
                            <span className="subscription-tooltip-icon">i</span>
                            <div className="subscription-tooltip-content">
                                {pageTooltip.map((item, idx) => (
                                    <p
                                        key={item.id || idx}
                                        style={{ margin: idx === 0 ? 0 : "6px 0 0" }}
                                    >
                                        {item.texto}
                                    </p>
                                ))}
                            </div>
                        </div>
                    )}
                </div>

                <div className="etapas">
                    {[1, 2, 3, 4].map((n) => {
                        const statusClass =
                            currentStep === n
                                ? "ativa"
                                : currentStep > n
                                    ? "completa"
                                    : "";
                        const label = [
                            "Montante",
                            "Termos e Condições",
                            "Confirmar dados",
                            "Finalizar",
                        ][n - 1];

                        return (
                            <div key={n} className={`etapa ${statusClass}`}>
                                <div className="bolinha">{n}</div>
                                <span>{label}</span>
                            </div>
                        );
                    })}
                    <div className="progresso-container">
                        <div
                            className="progresso-barra"
                            style={{ width: `${((currentStep - 1) / 3) * 100}%` }}
                        />
                    </div>
                </div>

                {this.renderPasso()}

                <div className="botoes">
                    {this.shouldShowBackButton() && (
                        <button
                            onClick={
                                this.state.currentStep === 1
                                    ? this.props.onClose
                                    : this.handleBack
                            }
                            className="botao voltar"
                        >
                            Voltar
                        </button>
                    )}

                    {this.shouldShowNextButton() && (
                        <button onClick={this.handleNext} className="botao laranja">
                            Continuar
                        </button>
                    )}

                    {this.shouldShowConfirmButton() && (
                        <button
                            onClick={this.handleSubmit}
                            className="botao verde"
                            disabled={this.state.subscricaoLoading}
                        >
                            {this.state.subscricaoLoading ? (
                                <div className="botao-spinner-wrapper">
                                    <img
                                        src={loadingImg}
                                        alt="Carregando"
                                        className="spinner-icon"
                                    />
                                    <span>A processar...</span>
                                </div>
                            ) : (
                                "Confirmar"
                            )}
                        </button>
                    )}

                    {this.shouldShowCloseButton() && (
                        <button onClick={this.props.onClose} className="botao verde">
                            Fechar
                        </button>
                    )}
                </div>
            </div>
        );
    }

    render() {
        const { currentStep } = this.state;
        return (
            <div className="form-container">
                {currentStep === 0 ? this.renderSeriesStep() : this.renderFormulario()}
            </div>
        );
    }
}

AddSubscription.contextType = ContextConstructor;
export default AddSubscription;